import i18n, { type Resource } from "i18next";
import { initReactI18next } from "react-i18next";

import german from "@/locales/de.json";
import english from "@/locales/en.json";
import { getStoredLanguage } from "@/libs/tours/utils";

export const LANGUAGE_STORAGE_KEY = "apomap_lng";

const availableLanguages = {
  de: {
    translation: german,
  },
  en: {
    translation: english,
  },
} as const satisfies Resource;

type Language = {
  code: keyof typeof availableLanguages;
  name: string;
  nativeName: string;
  flag: string;
};

export const languages: Language[] = [
  {
    code: "en",
    name: "English",
    nativeName: "English",
    flag: "🇬🇧",
  },
  {
    code: "de",
    name: "German",
    nativeName: "Deutsch",
    flag: "🇩🇪",
  },
];

export async function initializeI18n() {
  const storedLanguage = await getStoredLanguage();

  i18n.use(initReactI18next).init({
    resources: availableLanguages,
    lng: storedLanguage || "de",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });
}
